<template>
	<input type="text" class="FloatInputBox"  v-model="price_model" v-on:keyup.enter="onBlur()" v-on:blur="onBlur()" :disabled="readonly">
</template>
<script>
	export default {
		name: "FloatInputBox",
		props: {
			label: {
				default: ""
			},
			price: {
				default: ""
			},
			readonly : Boolean
		},
		model: {
			prop: 'price',
			event: 'input'
		},
		data: () => ({
			price_model: ""
		}),
		watch: {
			"price": function (n, o) {
				this.price_model = parseFloat(this.price).toFixed(3)
			}
		},
		mounted() {
			this.price_model = parseFloat(this.price).toFixed(3)
		},
		methods: {
			onBlur() {
				this.price_model = this.price_model.replace(/[^\d.-]/g, '');
				if (this.price_model == "") {
					this.price_model = 0
				}
				this.price_model = parseFloat(this.price_model).toFixed(3)
				this.$emit("input", parseFloat(this.price_model))
			}
		},
		computed: {

		}
	}
</script>

<style lang="less">
	.FloatInputBox {
		display: block;
		width: 100%;
		height: 40px;
		padding: 10px 12px;
		font-size: 13px;
		line-height: 1.428571429;
		color: #404040;
		background-color: #fff;
		background-image: none;
		border: 1px solid #d5d8de;
		border-radius: 2px;
		-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
		-webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
		-o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
		-webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
		transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
		transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
		transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;

		&:focus {
			border-color: #4285f4; 
			outline: 0;
		}
		&[disabled]{
			border: 1px solid #f3f3f3;
		}
	}
</style>